import script from "./StablePopover.vue?vue&type=script&setup=true&lang=js"
export * from "./StablePopover.vue?vue&type=script&setup=true&lang=js"

import "./StablePopover.vue?vue&type=style&index=0&id=22c2f0ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22c2f0ac"]])

export default __exports__